export const EMAIL = {
  Bonjour: 'bonjour@lychen.fr',
} as const;
